export const Education = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5001 13V9.49998L20.5001 8.49998M4.50006 10.5V15.9121C4.50006 16.6843 4.94465 17.3876 5.64226 17.7188L10.6423 20.0927C11.1851 20.3505 11.815 20.3505 12.3579 20.0927L17.3579 17.7188C18.0555 17.3876 18.5001 16.6843 18.5001 15.9121V10.5M11.2317 4.13414L2.57337 8.46332C2.13114 8.68444 2.13114 9.31552 2.57337 9.53664L11.2317 13.8658C11.4007 13.9503 11.5995 13.9503 11.7684 13.8658L20.4267 9.53664C20.869 9.31552 20.869 8.68444 20.4267 8.46332L11.7684 4.13414C11.5995 4.04969 11.4007 4.04969 11.2317 4.13414Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
